// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-34j_6","wrapper_disabled":"wrapper_disabled-3_vo1","login_button":"login_button--V-4X"};